const config = {
  apiBaseUrl: {
    logApi: "https://x9pe0dhpdg.execute-api.us-east-1.amazonaws.com/Prod",
    logApiID: "OxQ6o2hUzU7Chrqc1ofGj61oli0LvqKK4QivMJXb",
    claudeApi: "https://x9pe0dhpdg.execute-api.us-east-1.amazonaws.com/Prod",
    claudeApiID: "OxQ6o2hUzU7Chrqc1ofGj61oli0LvqKK4QivMJXb",
    kendraWebSocket:
      "wss://kafhapvi2f.execute-api.us-east-1.amazonaws.com/prod/",
    // AgentCore front door origin, no trailing slash. See apiConfigDev.js.
    agentApi: "",
  },
  features: {
    useKendraAPI: true, // Use product API in production
    // Stays false in prod until dev has been through a full cutover.
    useHttpStreaming: false,
  },
  cognito: {
    authority:
      "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_IcMlzhHTs",
    clientId: "6rnrn1tv21v64k4s5bdu6nn3au",
    logoutUri: "https://d39yxfcozskg29.cloudfront.com/logout",
    cognitoDomain:
      "https://prod-tnspay-iq-auth.auth.us-east-1.amazoncognito.com",
  },
  checkout: {
    checkoutApi:
      "https://tljk7p4lu9.execute-api.us-east-1.amazonaws.com/dev/api/",
    hostedCheckoutEndpoint:
      "https://checkouttest.dev.paymentgateway.tnsi.com/uat/dist/index.js",
    terminalSaleEndpoint:
      "https://tljk7p4lu9.execute-api.us-east-1.amazonaws.com/dev/api/payments/terminal/sale",
  },
};

export default config;

